import flatpickr from 'flatpickr';
import { Finnish } from 'flatpickr/dist/l10n/fi.js';

/**
 * Datetimepicker component that uses the Flatpickr library.
 *
 * https://flatpickr.js.org/
 *
 * @param {string} dateTimeFormat Default dateformat to use
 */
export default function (dateTimeFormat = 'j.n.Y H:i') {
    return {
        event: event,
        mounted: function () {
            if (this.$refs.pickerInput.disabled) {
                return;
            }

            flatpickr(this.$refs.pickerInput, {
                defaultDate: this.$refs.pickerInput.value,
                dateFormat: dateTimeFormat,
                maxDate: this.$refs.pickerInput.max,
                minDate: this.$refs.pickerInput.min,
                locale: Finnish,
                enableTime: true,
                time_24hr: true,
            });
        },
    };
}
